module.exports = __webpack_public_path__ + "img/step14_a_basket_basic_connect_top_cross_to_stand.31bc3333.png";